import { HelpCircle } from 'lucide-react';
import { NavItem } from '../types';

const helpItems: NavItem[] = [
  {
    title: 'Help',
    path: '/app/help',
    icon: HelpCircle,
    // No permissions required - all users should have access to help
  }
];

export default helpItems;